export interface IRewardCoinsUtil {
	segmentName: string;
	bonusUtil: number;
	cashbackUtil: number;
}
export interface IRewardCoinsUtilPriorityPayload {
	coinType: ESupportedRewardCoinsUtil;
	priorityList: string[];
}
export enum ESupportedRewardCoinsUtil {
	cashbackCoins = 'cashbackCoins',
	bonusCoins = 'bonusCoins'
}
export interface IDeleteRewardCoinsUtilPayload {
	segmentName: string;
}
export interface IRewardCoinsUtilResponse {
	dashboardListData: IRewardCoinsUtil[];
	bonusSegmentPriorityList: string[];
	cashbackSegmentPriorityList: string[];
	success: boolean;
}

export interface IUserPrioritySegementResponse {
	data: {
		userCTDPayoutSegments: string[];
		ctdUserSegmentPriorityList: string[];
		conversionConfig: {
			withdrawFeeSegmentList: [];
			ctdAmountLimitSegmentList: [];
			payoutAmountLimitSegmentList: [];
			coolOffSegmentList: [];
			ctdCoolOffSegmentList: [];
			payoutCoolOffSegmentList: [];
			leaveIntentSegmentList: [];
		};
	};
	success: boolean;
}

export interface RESPONSE {
	success: boolean;
	externalMessage?: string;
	message?: string;
}

export enum ESupportedCTDConfigPriority {
	userCtdPayoutSegments = 'userCTDPayoutSegments',
	ctdUserSegmentPriorityList = 'ctdUserSegmentPriorityList',
	withdrawFeeSegmentList = 'withdrawFeeSegmentList',
	ctdAmountLimitSegmentList = 'ctdAmountLimitSegmentList',
	payoutAmountLimitSegmentList = 'payoutAmountLimitSegmentList',
	coolOffSegmentList = 'coolOffSegmentList',
	ctdCoolOffSegmentList = 'ctdCoolOffSegmentList',
	payoutCoolOffSegmentList = 'payoutCoolOffSegmentList',
	leaveIntentSegmentList = 'leaveIntentSegmentList'
}

export interface SegmentInputTextState {
	userCTDPayoutSegments: string;
	ctdUserSegmentPriorityList: string;
	withdrawFeeSegmentList: string;
	ctdAmountLimitSegmentList: string;
	payoutAmountLimitSegmentList: string;
	coolOffSegmentList: string;
	payoutCoolOffSegmentList: string;
	ctdCoolOffSegmentList: string;
	leaveIntentSegmentList: string;
}

export interface SegmentState {
	userCTDPayoutSegments: string[];
	ctdUserSegmentPriorityList: string[];
	ctdAmountLimitSegmentList: string[];
	withdrawFeeSegmentList: string[];
	payoutAmountLimitSegmentList: string[];
	coolOffSegmentList: string[];
	ctdCoolOffSegmentList: string[];
	payoutCoolOffSegmentList: string[];
	leaveIntentSegmentList: string[];
}
